import { Button, Container, Grid, IconButton, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { FC, useState, useEffect } from 'react'
import { useHistory } from 'react-router'
import DataTable from '../component/report/expired/DataTable'
import Panel from '../component/report/expired/Panel'
import SearchAccordion from '../control/accordion/SearchAccordion'
import useTranslate from '../i18n/useTranslate'
import useAuthenStore from '../stores/authen/authenStore'
import useSearchExpired, {
    ExpiredResponseType,
    ExpiredSearchForm,
    ExpiredSearchProps,
} from '../services/um/useSearchExpired'
import moment, { lang } from 'moment'
import expiredExport from '../component/report/expired/report'
import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded'
import useProjectType from '../services/um/lookups/useProjectType'
import ArrowBackRounded from '@material-ui/icons/ArrowBackRounded'
import { convertDateToFormatEN, convertDateToFormatTH } from '../utilities/date'
import { useQueryParam } from 'use-query-params'
import { FormApi } from 'final-form'
import { setPrefixName } from '../utilities/prefixName'

const Expired: FC<any> = (props) => {
    const translate = useTranslate()
    const lang = translate.languageStore.currentLanguage as 'th' | 'en'
    const classes = useStyles()
    const history = useHistory()
    const authenStore = useAuthenStore()
    const [dataList, setDataList] = useState<ExpiredResponseType[]>([])
    const [records, setRecords] = useState<number>(0)
    const { getExpiredData } = useSearchExpired()
    const { projectT } = useProjectType()
    const [keyword, setKeyword] = useQueryParam<string | undefined>('keyword')
    const [projectType, setProjectType] = useQueryParam<number | undefined>('projectType')
    const [startDate, setStartDate] = useQueryParam<Date | string>('startDate')
    const [endDate, setEndDate] = useQueryParam<Date | string>('endDate')
    const initialSearch: ExpiredSearchForm = {
        keyword: keyword,
        projectType: projectType,
        startDate: startDate
            ? moment(startDate).format('YYYY-MM-DD')
            : moment().subtract(1, 'year').format('YYYY-MM-DD'),
        endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
    }

    const onSubmit = async (value: ExpiredSearchForm) => {
        const param: ExpiredSearchProps = {
            userID: authenStore.profile.userId ?? 0,
            keyword: value.keyword,
            projectType: value.projectType,
            startDate: moment(value.startDate).format('YYYY-MM-DD'), //'2021-08-01',
            endDate: moment(value.endDate).format('YYYY-MM-DD'), //'2021-09-10',
        }
        setSearchParam(value)
        loadData(param)
    }

    const setSearchParam = (value: ExpiredSearchForm) => {
        setKeyword(value.keyword)
        setProjectType(value.projectType)
        setStartDate(moment(value.startDate).format('YYYY-MM-DD') ?? '')
        setEndDate(moment(value.endDate).format('YYYY-MM-DD') ?? '')
    }

    const loadData = async (param: ExpiredSearchProps) => {
        const data = await getExpiredData(param)
        setRecords(data.length)
        setDataList(data)
    }

    const initialLoad = () => {
        const param: ExpiredSearchProps = {
            userID: authenStore.profile.userId ?? 0,
            keyword: keyword,
            projectType: projectType,
            startDate: startDate
                ? moment(startDate).format('YYYY-MM-DD')
                : moment().subtract(1, 'year').format('YYYY-MM-DD'),
            endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
        }
        setSearchParam(initialSearch)
        loadData(param)
    }

    const onReset = (form: FormApi<ExpiredSearchForm, Partial<ExpiredSearchForm>>) => {
        let param = {
            startDate: moment().subtract(1, 'year').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
        }
        form.initialize(param)
        setSearchParam(param)
    }

    const getProjectTypeName = (value?: number) => {
        let result = null
        if (value) {
            result = projectT.find((item) => item.value === projectType?.toString())?.label
        }
        return result ?? '-'
    }

    useEffect(() => {
        if (authenStore.profile.userId) {
            initialLoad()
        }
    }, [authenStore.profile.userId])

    const handleExportExcel = () => {
        let convertExportData = dataList.map((itm) => {
            return {
                projectID: itm.projectNumber ?? '-',
                endDate: convertDate(moment(itm.expiredDate).format('YYYY-MM-DD')) ?? '-',
                projectType: itm.projectType.name[lang] ?? '-',
                researcherName: setPrefixName(itm)[lang] ?? '-',
                position: itm.researcherTypeName[lang] ?? '-',
                projectNameTH: itm.projectName['th'] ?? '-',
                projectNameEN: itm.projectName['en'] ?? '-',
            }
        })

        expiredExport({
            header: {
                projectType: getProjectTypeName(projectType),
                startDate: convertDate(moment(startDate).format('YYYY-MM-DD')),
                endDate: convertDate(moment(endDate).format('YYYY-MM-DD')),
                keyword: keyword ?? '-',
            },
            content: convertExportData,
            translate: (value: string) => translate.get(value),
        })
    }
    const onBack = () => {
        history.push('/dashboard')
    }

    const convertDate = (date: string | null) => {
        if (lang === 'th' && date) {
            return convertDateToFormatTH(date)
        } else if (lang === 'en' && date) {
            return convertDateToFormatEN(date)
        } else {
            return '-'
        }
    }

    return (
        <Container maxWidth="lg">
            <Grid className={classes.root}>
                <SearchAccordion title={translate.get('UM.EXPIRED.HEADER')} isBack={true} onClickBack={onBack}>
                    <Panel
                        onSubmit={onSubmit}
                        initialSearch={{ keyword, projectType, startDate, endDate }}
                        onReset={onReset}
                    />
                </SearchAccordion>
                <Grid container justify="space-between" alignItems="center" className={classes.container}>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h6">
                            {translate.get('LABEL.SEARCH_TOTAL_RESULT', [`${records}`])}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Grid container justify="flex-end" spacing={2}>
                            <Grid item>
                                <Button
                                    size="large"
                                    variant="outlined"
                                    color="primary"
                                    startIcon={<GetAppRoundedIcon style={{ color: '#DB5F8E' }} />}
                                    onClick={handleExportExcel}
                                >
                                    <Typography variant="button">{translate.get('BUTTON.EXPORT')}</Typography>
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable data={dataList} />
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    container: {
        marginTop: '20px',
        width: '100%',
    },
}))
export default Expired
